import { render, staticRenderFns } from "./ItemViewDialog.vue?vue&type=template&id=3218cda8"
import script from "./ItemViewDialog.vue?vue&type=script&lang=js"
export * from "./ItemViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports